import { useMemo } from 'react';

import { useChartDataDisplay } from 'hooks/helperHooks';
import { pitchTypes } from 'utilities/constants';
import { pitchTypeToColor, pitchTypeGroupToColor } from 'utilities/colorHelpers';
import { GraphicalScatterChartDataset } from 'components/Charts/ScatterChart/ScatterChart';
import { ScatterChartDataset } from 'types/CodegenReportTypes';

const simulateChartData = (isLoading: boolean): ScatterChartDataset[] => {
  const chartData = pitchTypes
    .filter((pitchType) => pitchType !== 'Undefined')
    .map((pitchType) => ({
      label: pitchType,
      points: !isLoading
        ? []
        : [
            {
              x: Math.random() * 100,
              y: Math.random() * 100,
            },
            {
              x: Math.random() * 100,
              y: Math.random() * 100,
            },
          ],
    }));

  return chartData;
};

const useScatterChartData = (chartData: ScatterChartDataset[] | undefined, isLoading: boolean): GraphicalScatterChartDataset[] => {
  const chartDataDisplay = useChartDataDisplay(chartData, simulateChartData, isLoading);

  const mappedChartData = useMemo(
    () =>
      chartDataDisplay.map((data) => ({
        label: data.label,
        color: pitchTypeToColor[data.label] ?? pitchTypeGroupToColor[data.label],
        points: data.points,
      })) as GraphicalScatterChartDataset[],
    [chartDataDisplay]
  );

  return mappedChartData;
};

export default useScatterChartData;
